<template>
    <div>
        <step-one v-if="valuationStep == 1" @goToNext="goToNext"></step-one>
        <step-two
            v-if="valuationStep === 2"
            @goTofinal="goTofinal"
            @goToBack="goToBack"
        ></step-two>
        <step-three v-if="final === 1"  @goToBack="goToBack" :user_id="user_id"></step-three>
        <!-- <step-four v-if="valuationStep === 4"></step-four> -->
    </div>
</template>

<script>
import DirectPropertyValuationStepOne from "./DirectPropertyValuationStepOne.vue";
import DirectPropertyValuationStepThree from "./DirectPropertyValuationStepThree.vue";
import DirectPropertyValuationStepTwo from "./DirectPropertyValuationStepTwo.vue";
// import PropertyValuationStepNine from "./PropertyValuationStepNine.vue";

export default {
    name: "DirectPropertyValuation",
    props: {
        user_id: {
            default: "",
        },
    },
    components: {
        "step-one": DirectPropertyValuationStepOne,
        "step-two": DirectPropertyValuationStepTwo,
        "step-three": DirectPropertyValuationStepThree,
        // "step-four": PropertyValuationStepNine,
    },
    data() {
        return {
            valuationStep: 1,
            final: 0,
        };
    },
    computed: {},
    watch: {},
    mounted() {},
    methods: {
        goToNext() {
            this.valuationStep += 1;
        },
        goToBack() {
            this.valuationStep -= 1;
        },
        goTofinal() {
            this.final = 0;
            setTimeout(() => {
                this.final = 1;
                // this.valuationStep = 3;
            }, 300);
        },
    },
};
</script>

<style></style>
